import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, showMessageToastCustom } from '../../../../utils/util';
import { Input, Breadcrumbs, ConfirmButtons } from '../../../../components/UI/ComponentsUI';
import ContainerService from '../../../../services/ContainerService';
import { validateInputsRequired, onValueChange } from '../../../../utils/handleChangeHooks';
import { getVision } from '../../../../services/auth';
import { VISIONS } from '../../../../utils/constants';

const MaritimeCompanyInsert = (props) => {
    const update = props.location?.state?.update;
    const [data, setData] = useState(props.location?.state?.update && props.maritimeCompany ? props.maritimeCompany : {});

    const onChange = (event) => {
        onValueChange(event, data, setData);
    };

    const redirect = () => {
        props.history.replace('./list');
    }

    const onConfirm = () => {
        if (validateInputsRequired("maritimeInsert")) {
            if (update) {
                props.update(data, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        redirect();
                    }
                });
            } else {
                props.insert(data, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        redirect();
                    }
                });
            }
        }

    };

    const subtitlesPlant = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "mdi mdi-domain", label: "Comp. Marítimas" }];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'container') : translate('menu.insert', 'container') }];
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="plantInsert" title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('menu.container', 'container') }}
                subtitles={subtitlesPlant()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form id="maritimeInsert">
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding outlined col s11">
                                        <Input
                                            required
                                            label="Nome"
                                            id="name"
                                            name="name"
                                            maxLength={35}
                                            type="text"
                                            onChange={onChange}
                                            value={data?.name || ''} />
                                    </div>
                                    <div className="input-field no-padding outlined col s6">
                                        <Input
                                            required={getVision() === VISIONS.PortoReal || getVision() === VISIONS.Palomar}
                                            label="Código Flucomex"
                                            id="flucomexCode"
                                            name="flucomexCode"
                                            maxLength={3}
                                            type="number"
                                            onChange={onChange}
                                            value={data?.flucomexCode || ''} />
                                    </div>
                                    <div className="input-field no-padding outlined col s5">
                                        <Input
                                            required
                                            label="Código Ecomex"
                                            id="ecomexCode"
                                            name="ecomexCode"
                                            maxLength={3}
                                            type="number"
                                            onChange={onChange}
                                            value={data?.ecomexCode || ''} />
                                    </div>
                                </div>
                            </form>
                            <ConfirmButtons
                                onConfirm={() => onConfirm()}
                                onCancel={() => props.history.go(-1)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        maritimeCompany: state.containerReducer.maritimeCompany
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        insert: (data, callback) => {
            dispatch(ContainerService.insertMaritimeCompany(data, callback));
        },
        update: (data, callback) => {
            dispatch(ContainerService.updateMaritimeCompany(data, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MaritimeCompanyInsert)));
